import React from 'react'
import { createRoot } from 'react-dom/client'
import { WallShow } from "./../wall/Show";

const mount = () => {
  const node = document.getElementById('react-wall-show')
  if (!node) return
  const root = createRoot(node)
  root.render(<WallShow {...JSON.parse(node.getAttribute('data')) } />)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount, { once: true })
} else {
  mount()
}
